import Components from "./components";

export default function(parentDir: string) {
    const rootDir = `${parentDir}/common`;

    return angular.module("tfApp.store.common", [Components(rootDir)])
                  .name;
}
